import * as React from "react";
import { FieldInfo } from "rd-redux-forms";

export const arrayField = {
    toCheckbox: {
        checked<T>(field: FieldInfo, value: T): boolean {
            return (field.value || []).includes(value);
        },

        events<T>(field: FieldInfo, fieldEvents: any, value: T): any {
            return {
                onChange(e: React.ChangeEvent<HTMLInputElement>, reversed?: boolean) {
                    if (!reversed) {
                        fieldEvents.onChange(
                            e.currentTarget.checked
                                ? [...(field.value || []), value]
                                : (field.value || []).filter((el: any) => el !== value)
                        );
                    } else {
                        fieldEvents.onChange(
                            !e.currentTarget.checked
                                ? [...(field.value || []), value]
                                : (field.value || []).filter((el: any) => el !== value)
                        );
                    }
                }
            };
        }
    }
};
